import { render, staticRenderFns } from "./ModalStudentHistory.vue?vue&type=template&id=7e7d4942&scoped=true&lang=pug&"
import script from "./ModalStudentHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentHistory.vue?vue&type=style&index=0&id=7e7d4942&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7d4942",
  null
  
)

export default component.exports